import React from "react";

export const projectionFieldClass =
  "block w-full rounded-md border border-slate-300 bg-white px-2.5 py-1.5 text-sm tabular-nums text-slate-900 shadow-sm focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white";

export const projectionSelectClass =
  "block w-full rounded-md border border-slate-300 bg-white px-2.5 py-1.5 text-sm text-slate-900 shadow-sm focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white";

type ProjectionNumberFieldProps = {
  label?: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  suffix?: string;
  percent?: boolean;
  className?: string;
};

export const ProjectionNumberField: React.FC<ProjectionNumberFieldProps> = ({
  label,
  value,
  onChange,
  min,
  max,
  step,
  suffix,
  percent = false,
  className = "",
}) => {
  const display = percent ? Math.round(value * 1000) / 10 : value;
  return (
    <label className={`block ${className}`}>
      {label ? (
        <span className="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">{label}</span>
      ) : null}
      <div className="relative">
        <input
          type="number"
          className={`${projectionFieldClass} ${suffix ? "pr-10" : ""}`}
          value={Number.isFinite(display) ? display : 0}
          min={percent ? (min ?? 0) * 100 : min}
          max={percent ? (max ?? 1) * 100 : max}
          step={percent ? (step ?? 0.01) * 100 : step}
          onChange={(event) => {
            const next = Number(event.target.value);
            if (!Number.isFinite(next)) return;
            onChange(percent ? next / 100 : next);
          }}
        />
        {suffix ? (
          <span className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-xs text-slate-400">
            {suffix}
          </span>
        ) : null}
      </div>
    </label>
  );
};

type ProjectionSliderProps = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  hint?: string;
};

export const ProjectionSlider: React.FC<ProjectionSliderProps> = ({ label, value, onChange, hint }) => (
  <label className="block">
    <div className="mb-1 flex items-center justify-between gap-2">
      <span className="text-xs font-medium text-slate-600 dark:text-slate-300">{label}</span>
      <span className="text-xs font-semibold tabular-nums text-teal-700 dark:text-teal-300">
        {Math.round(value * 100)}%
      </span>
    </div>
    <input
      type="range"
      min={0}
      max={100}
      step={1}
      value={Math.round(value * 100)}
      onChange={(event) => onChange(Number(event.target.value) / 100)}
      className="h-2 w-full cursor-pointer appearance-none rounded-full bg-slate-200 accent-teal-600 dark:bg-gray-700"
    />
    {hint ? <p className="mt-1 text-[11px] text-slate-400">{hint}</p> : null}
  </label>
);
